import { loadingChunkRetry } from '@sit/client-shared';
import { lazy, Suspense } from 'react';
import DashboardContainer from '../DashboardContainer';
import { TimesheetModals } from './components/TimesheetModals';
import { TimesheetModalsProvider } from './components/TimesheetModalsProvider';

const Timesheets = lazy(() => loadingChunkRetry(() => import('./Timesheets')));

const TimesheetsContainer = () => {
  return (
    <DashboardContainer showSecondaryNav>
      <TimesheetModalsProvider>
        <Suspense fallback={null}>
          <TimesheetModals />
          <Timesheets />
        </Suspense>
      </TimesheetModalsProvider>
    </DashboardContainer>
  );
};

export default TimesheetsContainer;
